import { ParsedLocation, redirect } from '@tanstack/react-router'

import { RouterContext } from '@/routes/root'

import { isCurrentTokenValid } from './auth'

export type EnsureAuthenticatedUserProps = {
  location: ParsedLocation
  context: RouterContext
}

export const ensureAuthenticatedUser = async ({ location }: EnsureAuthenticatedUserProps) => {
  if (!isCurrentTokenValid()) {
    throw redirect({
      to: '/login',
      search: {
        redirect: location.href,
      },
    })
  }
}
